// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Cv8y","account":"styles_account__1GT-R","avatar":"styles_avatar__2YT31","logo":"styles_logo__5Hqfg"};